import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiSelectLabels',
  standalone: true,
  pure: true
})
export class MultiSelectLabelsPipe implements PipeTransform {
  transform(
    values: (string | number)[],
    options: { value: string | number; label: string }[]
  ): string[] {
    return values.map(val => {
      const option = options.find(opt => opt.value === val);
      return option ? option.label : val.toString();
    });
  }
}
